module.exports = __webpack_public_path__ + "img/cp5-1.bb45e54a.jpg";